module.exports = __webpack_public_path__ + "static/media/tutor-th-1.c3f5fcb3.jpg";